import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import Drag from 'v-drag'

Vue.use(ElementUI)
Vue.use(Drag)

new Vue({
  el: '#app',
  render: h => h(App)
})